// Uses the free PSGC (Philippine Standard Geographic Code) API
// https://psgc.gitlab.io/api/
const BASE = "https://psgc.gitlab.io/api";

export async function getRegions() {
  const res = await fetch(`${BASE}/regions/`);
  return res.json();
}

export async function getProvinces(regionCode) {
  const res = await fetch(`${BASE}/regions/${regionCode}/provinces/`);
  return res.json();
}

// For NCR, there are no provinces, so we use districts/cities directly
export async function getCitiesByRegion(regionCode) {
  const res = await fetch(`${BASE}/regions/${regionCode}/cities-municipalities/`);
  return res.json();
}

export async function getCitiesByProvince(provinceCode) {
  const res = await fetch(`${BASE}/provinces/${provinceCode}/cities-municipalities/`);
  return res.json();
}

export async function getBarangays(cityCode) {
  const res = await fetch(`${BASE}/cities-municipalities/${cityCode}/barangays/`);
  return res.json();
}
